import React, { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import axios from "axios";
import RouteWrapper from "./routes/RouteWrapper";
import OfflineScreen from "./components/common/OfflineScreen";

function App() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    window.addEventListener("app-offline", handleOffline);

    // Global Axios interceptor for error handling
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        // 1. Handle network/offline failures
        if (!error.response || error.code === "ERR_NETWORK" || error.message === "Network Error") {
          setIsOffline(true);
        }

        // 2. Sanitize internal server errors (500+)
        if (error.response && error.response.status >= 500) {
          error.message = "Internal Server Error. Please try again later.";
        }

        return Promise.reject(error);
      }
    );

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("app-offline", handleOffline);
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  return (
    <div className="appWrapper">
      {isOffline ? (
        <OfflineScreen onRetry={() => setIsOffline(false)} />
      ) : (
        <RouteWrapper />
      )}
      <Toaster
        position="top-right"
        reverseOrder={false}
        containerStyle={{
          zIndex: 99999999,
        }}
        toastOptions={{
          duration: 5000,
          style: {
            zIndex: 99999999,
          },
          success: {
            style: {
              background: "#dfffe7",
              color: "green",
              zIndex: 99999999,
            },
          },
          error: {
            style: {
              background: "#ffe6e6",
              color: "red",
              zIndex: 99999999,
            },
          },
        }}
      />
    </div>
  );
}

export default App;
